import {Bucket} from '@/types';
import {FormActionType} from '@/enum';
import {BucketVersioning} from '@/buckets/form/enum';

export const getNewVersioning = (bucket: Bucket | undefined, action: FormActionType, values: any) => {
  let value: BucketVersioning | undefined = BucketVersioning.ENABLED;
  if (!values.versioningEnabled) {
    // User is unchecking the enable-versioning checkbox.
    if (action === FormActionType.CREATE) {
      // Users can only create a bucket with versioning enabled or disabled. Checking
      // the enable-versioning box and then unchecking it should set it back to disabled
      // (undefined == disabled).
      value = undefined;
    } else {
      // The user is editing an existing bucket's versioning.
      if (bucket && bucket.versioning === BucketVersioning.DISABLED) {
        // The user is editing a bucket whose versioning was disabled, they checked the
        // enable-versioning checkbox, and then unchecked it. We should leave versioning
        // disabled.
        value = undefined;
      } else {
        // The user is editing a bucket whose versioning was enabled, and they unchecked
        // the enable-versioning checkbox. They could also be editing a bucket whose
        // versioning was suspended, checked the box, and then unchecked the box.
        value = BucketVersioning.SUSPENDED;
      }
    }
  }
  return value;
};
